import { render, staticRenderFns } from "./CadastroLimiteProtesto.vue?vue&type=template&id=60382e08&scoped=true&"
import script from "./CadastroLimiteProtesto.vue?vue&type=script&lang=js&"
export * from "./CadastroLimiteProtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60382e08",
  null
  
)

export default component.exports